const VERSION = '1.1.1';

const USER_COOKIE = 'ka-tools';

const GEO_LEVELS = [
    "Διαμέρισμα",
    "Νομός",
    "Δήμος",
    "Πόλη",
    "Περιοχή",
];

const GEO_MATCHES = {
    NEW_GEOS: 0,
    ESTATEWEB: 1,
    SPITOGATOS: 2,
    KRITIKES_AGGELIES: 3
};

const GEO = {
    LOCAL: 0,
    GOLDEN_HOME: 10,
}

export {
    VERSION,
    GEO_LEVELS,
    GEO_MATCHES,

    GEO,
    USER_COOKIE,
}
